import { LightningElement,api } from "lwc";
import { ButtonItem } from "./types";
export type { ButtonItem };

export default class Button extends LightningElement {
    @api buttonitem: ButtonItem = null!;
    @api disabled: boolean | null = null;
    @api label: string | null = null;
    
    private get hasButtonItem() {
        return this.buttonitem !== null;
    }

    handleButtonClick(){        
        if(!this.disabled) {
            this.dispatchEventMethod("buttonclick",{ buttonId: this.buttonitem.id, name: this.buttonitem.buttonLabel.value });
        }
    }

    dispatchEventMethod(eventName: string, eventDetail: { buttonId: string, name: string }){
        this.dispatchEvent(
            new CustomEvent(eventName, {
              detail: eventDetail,
            })
        );
    }
    
    private get isLabelASeparateProperty() {
        return (this.label) ? true : false; 
    }

    private get IsButtonIcon() {
        return (this.buttonitem?.type === "ICON") ? true : false; 
    }

    private get IsButtonBorder() {
        return (this.buttonitem?.type === "BORDER") ? true : false; 
    }

    private get IsButtonBrand() {
        return (this.buttonitem?.type === "BRAND") ? true : false; 
    }
}
